import {ActionCreatorDefinition, createAction} from "redux-ts";
import {CreditCardState} from "core/redux/deposit/DepositReduxState";
import {Currency} from "platform/enum/Currency";
import {
    BankDetail, ClientDetail,
    DepositCreditCard,
    DepositCurrency,
    PaymentProvider
} from "protocol/response/GetDepositConfigurationsResponse";
import {TSMap} from "typescript-map";
import {NumberPayload} from "core/redux/StoreActions";
import {ReceiptDetails} from "protocol/request/DepositByCreditCardResponse";

export const SetDepositConfigurationType: string = "SetDepositConfiguration";
export const SetDepositAmountType: string = "SetDepositAmount";
export const TryChangeCurrencyType: string = "TryChangeCurrency";
export const SetDepositCurrencyType: string = "SetDepositCurrency";
export const SetPaymentMethodType: string = "SetPaymentMethod";
export const SetCreditCardProviderType: string = "SetCreditCardProvider";
export const SetCreditCardType: string = "SetCreditCard";
export const SetCreditCardValidType: string = "SetCreditCardValid";
export const SelectBankCurrencyType: string = "SelectBankCurrency";
export const SelectBankType: string = "SelectBank";
export const DoSubmitDepositCCType: string = "DoSubmitDepositCC";
export const DoSubmitDepositAPMType: string = "DoSubmitDepositAPM";
export const SetReceiptDetailsType: string = "SetReceiptDetails";
export const SetCreditCardIdType: string = "SetCreditCardId";
export const SetSavedCreditCardsType: string = "SetSavedCreditCards";
export const AddSavedCreditCardType: string = "AddSavedCreditCard";
export const RemoveSavedCreditCardType: string = "RemoveSavedCreditCard";

export interface SetDepositConfigurationPayload {

    Currencies: TSMap<Currency, DepositCurrency>;
    CreditCards: DepositCreditCard[];
    PaymentProviders: TSMap<number, PaymentProvider>;
    PaymentMethods: Array<string | number>;
    PlatformUrl: string;
    BanksCurrencies: Currency[];
    Banks: TSMap<Currency, BankDetail[]>;
    BankSelection: TSMap<Currency, BankDetail>;
    Client: ClientDetail;
}

export interface CurrencyPayload {

    currency: Currency;
}

export interface SetPaymentMethodPayload {

    paymentMethod: string | number;
}

export interface SetCreditCardProviderPayload {

    creditCardType: string;
    maxCardLength: number;
}

export interface SetCreditCardValidPayload {

    valid: boolean;
}

export interface SetCreditCardPayload {

    creditCard: CreditCardState;
}

export interface SelectBankCurrencyPayload {

    currency: Currency;
}

export interface SelectBankPayload {

    bank: BankDetail;
}

export interface DoSubmitDepositCCPayload {

    values: CreditCardState;
}

export interface DoSubmitDepositAPMPayload {

    values: any;
}

export interface SetReceiptDetailsPayload {

    details: ReceiptDetails;
}

export interface SetCreditCardIdPayload {

    creditCardId: string;
}

export interface SetSavedCreditCardsPayload {

    savedCreditCards: CreditCardState[];
}

export interface AddSavedCreditCardPayload {

    creditCard: CreditCardState;
}

export interface RemoveSavedCreditCardPayload {

    creditCardId: string;
}

export const SetDepositConfiguration: ActionCreatorDefinition<SetDepositConfigurationPayload, any> = createAction<SetDepositConfigurationPayload>(SetDepositConfigurationType);
export const SetDepositAmount: ActionCreatorDefinition<NumberPayload, any> = createAction<NumberPayload>(SetDepositAmountType);
export const TryChangeCurrency: ActionCreatorDefinition<CurrencyPayload, any> = createAction<CurrencyPayload>(TryChangeCurrencyType);
export const SetDepositCurrency: ActionCreatorDefinition<CurrencyPayload, any> = createAction<CurrencyPayload>(SetDepositCurrencyType);
export const SetPaymentMethod: ActionCreatorDefinition<SetPaymentMethodPayload, any> = createAction<SetPaymentMethodPayload>(SetPaymentMethodType);
export const SetCreditCardProvider: ActionCreatorDefinition<SetCreditCardProviderPayload, any> = createAction<SetCreditCardProviderPayload>(SetCreditCardProviderType);
export const SetCreditCard: ActionCreatorDefinition<SetCreditCardPayload, any> = createAction<SetCreditCardPayload>(SetCreditCardType);
export const SetCreditCardValid: ActionCreatorDefinition<SetCreditCardValidPayload, any> = createAction<SetCreditCardValidPayload>(SetCreditCardValidType);
export const SelectBankCurrency: ActionCreatorDefinition<SelectBankCurrencyPayload, any> = createAction<SelectBankCurrencyPayload>(SelectBankCurrencyType);
export const SelectBank: ActionCreatorDefinition<SelectBankPayload, any> = createAction<SelectBankPayload>(SelectBankType);
export const DoSubmitDepositCC: ActionCreatorDefinition<DoSubmitDepositCCPayload, any> = createAction<DoSubmitDepositCCPayload>(DoSubmitDepositCCType);
export const DoSubmitDepositAPM: ActionCreatorDefinition<DoSubmitDepositAPMPayload, any> = createAction<DoSubmitDepositAPMPayload>(DoSubmitDepositAPMType);
export const SetReceiptDetails: ActionCreatorDefinition<SetReceiptDetailsPayload, any> = createAction<SetReceiptDetailsPayload>(SetReceiptDetailsType);
export const SetCreditCardId: ActionCreatorDefinition<SetCreditCardIdPayload, any> = createAction<SetCreditCardIdPayload>(SetCreditCardIdType);
export const SetSavedCreditCards: ActionCreatorDefinition<SetSavedCreditCardsPayload, any> = createAction<SetSavedCreditCardsPayload>(SetSavedCreditCardsType);
export const AddSavedCreditCard: ActionCreatorDefinition<AddSavedCreditCardPayload, any> = createAction<AddSavedCreditCardPayload>(AddSavedCreditCardType);
export const RemoveSavedCreditCard: ActionCreatorDefinition<RemoveSavedCreditCardPayload, any> = createAction<RemoveSavedCreditCardPayload>(RemoveSavedCreditCardType);
